import { atom } from 'recoil'

const themeState = atom({
  key: 'themeState',
  default: 'home'
})

export default themeState
